import './_collection-three-card-module.scss';

export default () => {};
